// hooks/useActiveCategory.js
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const menuData = [
  {
    name: 'INICIO',
    path: 'inicio',
    slug: 'inicio',
    url: '/',
  },
  {
    name: 'EMPAQUE Y LOGÍSTICA',
    path: 'empaque-logistica',
    slug: 'empaque-logistica',
    url: '/category/empaque-y-logistica',
    subcategories: [
      {
        name: 'Almacenamiento, Manejo de Cargas y Seguridad Logística',
        path: 'almacenamiento',
        slug: 'almacenamiento-manejo-de-cargas-y-seguridad-logistica',
        url: '/category/almacenamiento-manejo-de-cargas-y-seguridad-logistica',
      },
      {
        name: 'Cajas, Protección y Embalaje de Cartón',
        path: 'cajas',
        slug: 'cajas-proteccion-y-embalaje-de-carton',
        url: '/category/cajas-proteccion-y-embalaje-de-carton',
      },
      {
        name: 'Cintas y Adhesivos',
        path: 'cintas',
        slug: 'cintas-y-adhesivos',
        url: '/category/cintas-y-adhesivos',
      },
      {
        name: 'Embalaje y Unitización de Cargas',
        path: 'embalaje',
        slug: 'embalaje-y-unitizacion-de-cargas',
        url: '/category/embalaje-y-unitizacion-de-cargas',
        subsubcategories: [
          {
            name: 'Fleje',
            path: 'fleje',
            slug: 'fleje',
            url: '/category/fleje',
          },
          {
            name: 'Película Stretch',
            path: 'stretch',
            slug: 'pelicula-stretch',
            url: '/category/pelicula-stretch',
          },
          {
            name: 'Película Termoencogible',
            path: 'termoencogible',
            slug: 'pelicula-termoencogible',
            url: '/category/pelicula-termoencogible',
          },
          {
            name: 'Rafia',
            path: 'rafia',
            slug: 'rafia',
            url: '/category/rafia',
          },
          {
            name: 'Stretch Hood',
            path: 'stretch-hood',
            slug: 'stretch-hood',
            url: '/category/stretch-hood',
          },
        ],
      },
      {
        name: 'Empaque Protector, Relleno y Comercio Electrónico',
        path: 'empaque-protector',
        slug: 'empaque-protector-relleno-y-comercio-electronico',
        url: '/category/empaque-protector-relleno-y-comercio-electronico',
      },
      {
        name: 'Maquinaria',
        path: 'maquinaria',
        slug: 'maquinaria',
        url: '/category/maquinaria',
      },
    ],
  },
  {
    name: 'SUMINISTROS INSTITUCIONALES',
    path: 'suministros',
    slug: 'suministros-institucionales',
    url: '/category/suministros-institucionales',
    subcategories: [
      {
        name: 'Equipo de Protección Personal',
        path: 'proteccion',
        slug: 'equipo-de-proteccion-personal',
        url: '/category/equipo-de-proteccion-personal',
      },
      {
        name: 'Higiene y Limpieza',
        path: 'higiene',
        slug: 'higiene-y-limpieza',
        url: '/category/higiene-y-limpieza',
      },
      {
        name: 'Soluciones para Food Service',
        path: 'food-service',
        slug: 'soluciones-para-food-service',
        url: '/category/soluciones-para-food-service',
      },
    ],
  },
  {
    name: 'GLOSARIO Y FORMACIÓN',
    path: 'glosario',
    slug: 'glosario-y-formacion',
    url: '/category/glosario-y-formacion',
    subcategories: [
      {
        name: 'Definiciones',
        path: 'definiciones',
        slug: 'definiciones',
        url: '/category/definiciones',
      },
      {
        name: 'Historia',
        path: 'historia',
        slug: 'historia',
        url: '/category/historia',
      },
      {
        name: 'Materiales',
        path: 'materiales',
        slug: 'materiales',
        url: '/category/materiales',
      },
    ],
  },
  {
    name: 'TIENDA PACKSYS',
    path: 'tienda',
    url: 'https://packsys.com/',
  },
];

// 🔥 FUNCIÓN findCategoryByUrl
// FUNCIÓN findCategoryByUrl
const findCategoryByUrl = (url) => {
  for (const category of menuData) {
    if (category.url === url || `/${category.slug}` === url) {
      return { category: category.path, subcategory: '', subsubcategory: '' };
    }

    if (category.subcategories) {
      for (const subcategory of category.subcategories) {
        if (subcategory.url === url || `/${subcategory.slug}` === url) {
          return {
            category: category.path,
            subcategory: subcategory.path,
            subsubcategory: '',
          };
        }

        if (subcategory.subsubcategories) {
          for (const subsubcategory of subcategory.subsubcategories) {
            if (
              subsubcategory.url === url ||
              `/${subsubcategory.slug}` === url
            ) {
              return {
                category: category.path,
                subcategory: subcategory.path,
                subsubcategory: subsubcategory.path,
              };
            }
          }
        }
      }
    }
  }
  return null;
};

const useActiveCategory = () => {
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState({
    category: '',
    subcategory: '',
    subsubcategory: '',
  });

  // ESCUCHAR EVENTOS de ArticleDetail
  useEffect(() => {
    const handleArticleCategoryLoaded = (event) => {
      setActiveMenu(event.detail);
      localStorage.setItem('lastActiveCategory', JSON.stringify(event.detail));
    };

    window.addEventListener(
      'articleCategoryLoaded',
      handleArticleCategoryLoaded
    );

    return () => {
      window.removeEventListener(
        'articleCategoryLoaded',
        handleArticleCategoryLoaded
      );
    };
  }, []);

  // MANEJAR CAMBIOS DE RUTA
  useEffect(() => {
    const currentPath = location.pathname;

    // Si es la página de inicio
    if (currentPath === '/') {
      const newActive = {
        category: 'inicio',
        subcategory: '',
        subsubcategory: '',
        mainCategory: 'inicio',
      };
      setActiveMenu(newActive);
      localStorage.setItem('lastActiveCategory', JSON.stringify(newActive));
      return;
    }

    // Si es una página de artículo - usar evento o última categoría guardada
    if (currentPath.startsWith('/article/')) {
      try {
        const lastCategory = localStorage.getItem('lastActiveCategory');
        if (lastCategory) {
          setActiveMenu(JSON.parse(lastCategory));
        } else {
          console.log('⚠️ No hay última categoría en localStorage');
        }
      } catch (error) {
        console.error('Error loading last category:', error);
      }
      return;
    }

    // Si es una página de categoría
    const foundCategory = findCategoryByUrl(currentPath);
    if (foundCategory) {
      const categoryWithMain = {
        ...foundCategory,
        mainCategory: foundCategory.category, // Para el footer
      };
      setActiveMenu(categoryWithMain);
      localStorage.setItem(
        'lastActiveCategory',
        JSON.stringify(categoryWithMain)
      );
    } else {
      console.log('❌ Categoría no encontrada por URL:', currentPath);
    }
  }, [location.pathname]);

  return { activeMenu, setActiveMenu };
};

export default useActiveCategory;
